module.exports = __webpack_public_path__ + "img/software-talent.4a1a3015.svg";